<template>
  <div>
    <dx-popup @shown="uxShown" @hidden="uxHidden"
      ref="dialog"
      v-model:visible="visibleComputed"
      :full-screen="fullScreen"
      :title="title"
      :showCloseButton="true"
      :hideOnOutsideClick="false"
    >
      <dx-toolbar-item
        toolbar="bottom"
        location="before"
        widget="dxButton"
        :options="batalOptions"
      >
      </dx-toolbar-item>
      <dx-toolbar-item
        toolbar="bottom"
        location="after"
        widget="dxButton"
        :options="simpanOptions"
      >
      </dx-toolbar-item>
      <dx-scroll-view height="100%" width="100%">
        <slot></slot>
      </dx-scroll-view>
    </dx-popup>
  </div>
</template>

<script>
import { uxDialogMixin } from "@/ux/dialog-watch";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import { DxScrollView } from "devextreme-vue/scroll-view";

export default {
  mixins: [uxDialogMixin],
  components: {
    DxPopup,
    DxToolbarItem,
    DxScrollView,
  },
  computed: {
    visibleComputed: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
  methods: {},
  props: {
    fullScreen: {
      type: Boolean,
      default: false,
    },
    title: String,
    visible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:visible", "simpan"],
  data() {
    return {
      batalOptions: {
        text: "Batal",
        icon: "fa-solid fa-times",
        onClick: () => {
          this.$emit("update:visible", false);
        },
      },
      simpanOptions: {
        text: "Simpan",
        icon: "fa-solid fa-save",
        type: "success",
        onClick: () => {
          this.$emit("simpan");
        },
      },
    };
  },
};
</script>
